<script setup lang="ts">
const router = useRouter();

const goBack = () => {
  if (router.options.history.state.back !== null) {
    router.back();
  } else {
    router.push('/');
  }
};
</script>

<template>
  <div :class="$style.back" @click="goBack">
    <Icon name="my-icon:i-back-arrow" :size="20" :class="$style.back__icon" />
    Назад
  </div>
</template>

<style module lang="scss">
.back {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 5px;
  text-decoration: none;
  justify-content: center;
  @include text_caption1_caps;
  color: var(--color-gray-text);
  cursor: pointer;

  &__icon {
    path {
      fill: var(--color-gray-text);
    }
  }
}
</style>
